import { render } from "./CPOCreation.vue?vue&type=template&id=12dc7e5e"
import script from "./CPOCreation.vue?vue&type=script&lang=js"
export * from "./CPOCreation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__